import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { EmployeeActivities } from '../_models/employeeActivities';
import { EmployeeActivitiesChartData } from '../EmployeeActivitesChartData';
import { EmployeeActivitiesPlanData } from '../employeeActivitiesPlanData';

@Injectable()
export class EmployeeActivityService {
  private apiBaseUrl = environment.apiBaseUrl;
  private activitiesChartMap: BehaviorSubject<Map<string, EmployeeActivitiesChartData>> =
    new BehaviorSubject<Map<string, EmployeeActivitiesChartData>>(
      new Map<string, EmployeeActivitiesChartData>()
    );

  private activitiesPlanMap: BehaviorSubject<Map<string, Array<EmployeeActivitiesPlanData>>> =
    new BehaviorSubject<Map<string, Array<EmployeeActivitiesPlanData>>>(
      new Map<string, Array<EmployeeActivitiesPlanData>>()
    );

  constructor(private http: HttpClient) {}

  getActivitiesChartMap = () => {
    return this.activitiesChartMap.asObservable();
  };

  updateActivitiesChartMap(activitiesMap: Map<string, EmployeeActivitiesChartData>) {
    this.activitiesChartMap.next(activitiesMap);
  }

  getActivitiesPlanMap = () => {
    return this.activitiesPlanMap.asObservable();
  };

  updateActivitiesPlanMap(activitiesPlanMap: Map<string, Array<EmployeeActivitiesPlanData>>) {
    this.activitiesPlanMap.next(activitiesPlanMap);
  }

  getEmployeeActivitiesOPModule(
    farmsAppend,
    unit,
    startDate,
    endDate
  ): Observable<EmployeeActivities[]> {
    const queryString =
      farmsAppend + '&unit=' + unit + '&startDate=' + startDate + '&endDate=' + endDate;
    return this.http
      .get<
        EmployeeActivities[]
      >(this.apiBaseUrl + 'api/private/v2/employeeActivities' + queryString)
      .pipe(map((response) => response));
  }
}
